import { Skeleton } from "@mui/material";
import { PromotionBanner } from "@src/appV2/redesign/system/ui-components";
import { useHistory } from "react-router-dom";

import { useNCOrientationStatus } from "./useNCOrientationStatus";

interface NCOrientationBannerProps {
  navigationPath: string;
}

export function NCOrientationBanner(props: NCOrientationBannerProps) {
  const { navigationPath } = props;
  const history = useHistory();
  const { shouldShow, isLoading } = useNCOrientationStatus();

  if (isLoading) {
    return <Skeleton variant="rounded" height={220} sx={{ borderRadius: 3, minWidth: 280 }} />;
  }

  if (!shouldShow) {
    return null;
  }

  return (
    <PromotionBanner
      title="North Carolina Orientation"
      subtitle="You must complete this orientation before booking shifts in North Carolina."
      icon="unlock"
      borderVariant="none"
      backgroundColor={(theme) => theme.palette.documents!.warning.gradient}
      titleColor={(theme) => theme.palette.text.primary}
      ctaButtonText="Start Orientation"
      sx={(theme) => ({
        border: `1px solid ${theme.palette.divider}`,
        "& svg": { alignSelf: "flex-start" },
      })}
      onClick={() => {
        history.push(navigationPath);
      }}
    />
  );
}
